/** Optional display metadata on an immutable Experience version. */
export type ExperienceMetadata = {
  shortCode?: string;
  displayColor?: string;
  discoveryTag?: string;
  campaignTag?: string;
  outdoor?: boolean;
  sameBusinessLocation?: boolean;
  addressOverride?: string;
  address2?: string;
  posSku?: string;
};

export const experienceDiscoveryTags = ["Beer tasting", "Class", "Event", "Kitchen table", "Liquor tasting", "Other", "Reservation", "Tasting menu", "Tour", "Wine tasting", "Virtual"];

export function experienceMetadataError(value: ExperienceMetadata): string | null {
  const code = value.shortCode?.trim();
  if (code && !/^[A-Z0-9]{2,5}$/.test(code.toUpperCase())) return "Short code must contain 2–5 letters or numbers.";
  if (value.displayColor && !/^(#[0-9A-Fa-f]{6}|[A-Za-z]{1,32})$/.test(value.displayColor)) return "Choose a valid experience color.";
  if (value.sameBusinessLocation === false && !value.addressOverride?.trim()) return "Enter the address for this experience, or use the business location.";
  return null;
}

export function experienceMetadataPayload(value: ExperienceMetadata): ExperienceMetadata {
  return {
    shortCode: value.shortCode?.trim().toUpperCase() || undefined,
    displayColor: value.displayColor || undefined,
    discoveryTag: value.discoveryTag?.trim() || undefined,
    campaignTag: value.campaignTag?.trim() || undefined,
    outdoor: value.outdoor ?? false,
    sameBusinessLocation: value.sameBusinessLocation ?? true,
    addressOverride: value.sameBusinessLocation === false ? value.addressOverride?.trim() : undefined,
    address2: value.address2?.trim() || undefined,
    posSku: value.posSku?.trim() || undefined,
  };
}
